// The 16-field contract. Order here === CSV column order.
export const VENDOR_FIELDS = [
  { key: "company_name", label: "Company Name", csv: "Company Name", width: 240, group: "Identity", required: true },
  { key: "contact_person", label: "Contact Person", csv: "Contact Person", width: 180, group: "Identity" },
  { key: "mobile", label: "Mobile", csv: "Mobile", width: 150, group: "Contact", mono: true },
  { key: "email", label: "Email", csv: "Email", width: 230, group: "Contact" },
  { key: "address", label: "Address", csv: "Address", width: 260, group: "Address", long: true },
  { key: "city", label: "City", csv: "City", width: 140, group: "Address" },
  { key: "state", label: "State", csv: "State", width: 140, group: "Address" },
  { key: "pin", label: "PIN", csv: "PIN", width: 110, group: "Address", mono: true },
  { key: "pan", label: "PAN", csv: "PAN", width: 150, group: "Tax", mono: true, upper: true, required: true },
  { key: "gstin", label: "GSTIN", csv: "GSTIN", width: 190, group: "Tax", mono: true, upper: true },
  { key: "account_holder_name", label: "Account Holder Name", csv: "Account Holder Name", width: 230, group: "Bank" },
  { key: "bank_name", label: "Bank Name", csv: "Bank Name", width: 180, group: "Bank" },
  { key: "account_number", label: "Account Number", csv: "Account Number", width: 200, group: "Bank", mono: true, required: true },
  { key: "ifsc", label: "IFSC", csv: "IFSC", width: 150, group: "Bank", mono: true, upper: true, required: true },
  { key: "branch", label: "Branch", csv: "Branch", width: 170, group: "Bank" },
  { key: "reason_comments", label: "Reason / Comments", csv: "Reason/Comments", width: 340, group: "Notes", long: true },
];

export const FIELD_KEYS = VENDOR_FIELDS.map((f) => f.key);
export const CSV_HEADERS = VENDOR_FIELDS.map((f) => f.csv);

export const FIELD_GROUPS = ["Identity", "Contact", "Address", "Tax", "Bank", "Notes"];

export const emptyVendor = () => {
  const row = { _rid: `row-${Math.random().toString(36).slice(2, 10)}` };
  FIELD_KEYS.forEach((k) => {
    row[k] = "";
  });
  return row;
};

export const toRow = (vendor) => {
  const row = { _rid: `row-${Math.random().toString(36).slice(2, 10)}` };
  FIELD_KEYS.forEach((k) => {
    row[k] = vendor?.[k] ?? "";
  });
  return row;
};

export const toPayload = (rows) =>
  rows.map((r) => {
    const out = {};
    FIELD_KEYS.forEach((k) => {
      out[k] = r[k] ?? "";
    });
    return out;
  });
